import { MenuItem, Text } from '@electricjs/arc';
import { AssetsMdmStatus } from '@electricjs/core_entity-client';
import { useTranslation } from 'react-i18next';
import { useGetOrganizationId } from '@/hooks/useGetOrganizationId';
import { useUpdateMdmStatusOverride } from '@/hooks/useUpdateMdmStatusOverride';
import { Asset } from '@/types/assets';

type ExemptFromMdmMenuItemProps = {
  asset: Asset;
};

const ExemptFromMdmMenuItem = ({ asset }: ExemptFromMdmMenuItemProps) => {
  const { t } = useTranslation('assets');
  const organizationId = useGetOrganizationId();
  const { markNotApplicable, revokeExemption, isLoading } =
    useUpdateMdmStatusOverride(organizationId);

  const isExempt = asset.mdmStatusOverride === AssetsMdmStatus.NotApplicable;

  const handleClick = async () => {
    if (isExempt) {
      await revokeExemption(asset);
    } else {
      await markNotApplicable(asset);
    }
  };

  return (
    <MenuItem
      id="exempt-from-mdm-menu-item"
      onClick={handleClick}
      disabled={isLoading}>
      <Text>
        {isExempt
          ? t('assetDetailsButtonMenu.revokeMdmExemption')
          : t('assetDetailsButtonMenu.exemptFromMdm')}
      </Text>
    </MenuItem>
  );
};

export default ExemptFromMdmMenuItem;
